import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10" }
const _hoisted_3 = { class: "lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8 px-6" }
const _hoisted_4 = { class: "lg:pr-4" }
const _hoisted_5 = { class: "lg:max-w-lg" }
const _hoisted_6 = { class: "lg:sticky lg:top-24 lg:col-start-2 lg:row-span-2 lg:row-start-1 overflow-hidden pl-6" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8 px-6" }
const _hoisted_9 = { class: "lg:pr-4" }
const _hoisted_10 = { class: "max-w-xl text-base/7 lg:max-w-lg" }

import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import EditableElement from "@/views/page/EditableElement.vue";
import { computed } from "vue";
import SectionContainer from "@/views/blocks/shared/section/container/SectionContainer.vue";
import type { WithStickyProductScreenshotProps } from "./long-form.interfaces";
import SectionTag from "@/views/blocks/shared/section/tag/SectionTag.vue";
import SectionTitle from "@/views/blocks/shared/section/title/SectionTitle.vue";
import SectionDescription from "@/views/blocks/shared/section/description/SectionDescription.vue";
import Feature from "@/views/blocks/shared/section/features/Feature.vue";
import Features from "@/views/blocks/shared/section/features/Features.vue";
import { MarkdownHtml } from "@easy/ui/text";


export default /*@__PURE__*/_defineComponent({
  __name: 'WithStickyProductScreenshot',
  props: {
    block: {},
    pageColors: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SectionContainer, {
    id: _ctx.block.webId,
    class: "relative isolate",
    backgroundColor: styleValues.value.background
  }, {
    default: _withCtx(() => [
      (!dataValues.value.backgroundImage.isHidden)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: dataValues.value.backgroundImage.data.src,
            style: _normalizeStyle({
                opacity: dataValues.value.backgroundImage.data.transparency / 100,
            }),
            class: "absolute inset-0 -z-10 size-full object-cover mix-blend-multiply"
          }, null, 12, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (!dataValues.value.tag.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    fieldName: "tag"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SectionTag, {
                        text: dataValues.value.tag.data.text,
                        textColor: styleValues.value.brand
                      }, null, 8, ["text", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.title.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 1,
                    blockId: _ctx.block.id,
                    fieldName: "title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SectionTitle, {
                        class: "mt-2 text-4xl sm:text-5xl",
                        text: dataValues.value.title.data.text,
                        tag: dataValues.value.title.data.tag,
                        textColor: styleValues.value.text
                      }, null, 8, ["text", "tag", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.description.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 2,
                    blockId: _ctx.block.id,
                    fieldName: "description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SectionDescription, {
                        class: "opacity-70",
                        text: dataValues.value.description.data.text,
                        textColor: styleValues.value.text
                      }, null, 8, ["text", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (!dataValues.value.image.isHidden)
            ? (_openBlock(), _createBlock(EditableElement, {
                key: 0,
                blockId: _ctx.block.id,
                fieldName: "image"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "w-[48rem] max-w-none rounded-xl shadow-xl sm:w-[57rem]",
                    src: dataValues.value.image.data.src,
                    alt: dataValues.value.image.data.alt
                  }, null, 8, _hoisted_7)
                ]),
                _: 1
              }, 8, ["blockId"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (!dataValues.value.topText.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    fieldName: "topText"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MarkdownHtml), {
                        class: "opacity-70",
                        markdown: dataValues.value.topText.data.text,
                        style: _normalizeStyle({ color: styleValues.value.text })
                      }, null, 8, ["markdown", "style"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              _createVNode(Features, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.features.data.items, (feature) => {
                    return (_openBlock(), _createBlock(EditableElement, {
                      key: feature.id,
                      blockId: _ctx.block.id,
                      fieldName: `features_${feature.id}`,
                      hideable: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(Feature, {
                          title: feature.title,
                          description: feature.description,
                          iconSrc: feature.iconSrc,
                          titleTextColor: styleValues.value.text,
                          descriptionTextColor: styleValues.value.text
                        }, null, 8, ["title", "description", "iconSrc", "titleTextColor", "descriptionTextColor"])
                      ]),
                      _: 2
                    }, 1032, ["blockId", "fieldName"]))
                  }), 128))
                ]),
                _: 1
              }),
              (!dataValues.value.bottomText.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 1,
                    blockId: _ctx.block.id,
                    fieldName: "bottomText"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MarkdownHtml), {
                        class: "mt-8 opacity-70",
                        markdown: dataValues.value.bottomText.data.text,
                        style: _normalizeStyle({ color: styleValues.value.text })
                      }, null, 8, ["markdown", "style"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.secondaryTitle.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 2,
                    blockId: _ctx.block.id,
                    fieldName: "secondaryTitle"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(dataValues.value.secondaryTitle.data.tag), {
                        class: "mt-16 text-2xl font-bold tracking-tight",
                        style: _normalizeStyle({ color: styleValues.value.text })
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(dataValues.value.secondaryTitle.data.text), 1)
                        ]),
                        _: 1
                      }, 8, ["style"]))
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.secondaryDescription.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 3,
                    blockId: _ctx.block.id,
                    fieldName: "secondaryDescription"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MarkdownHtml), {
                        class: "mt-6 text-lg/8 opacity-70",
                        markdown: dataValues.value.secondaryDescription.data.text,
                        style: _normalizeStyle({ color: styleValues.value.text })
                      }, null, 8, ["markdown", "style"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["id", "backgroundColor"]))
}
}

})